import { Quote, SaveQuoteDraftData } from '../types/quote';
import apiClient from './client';

export async function getQuotesForThread(jobId: number, contractorProfileId: number): Promise<Quote[]> {
  const response = await apiClient.get<Quote[]>('/Quote/thread', { params: { jobId, contractorProfileId } });
  return response.data;
}

export async function getQuoteById(id: number): Promise<Quote> {
  const response = await apiClient.get<Quote>(`/Quote/${id}`);
  return response.data;
}

export async function createQuote(jobId: number): Promise<Quote> {
  const response = await apiClient.post<Quote>(`/Quote/job/${jobId}`, {});
  return response.data;
}

export async function saveQuoteDraft(quoteId: number, data: SaveQuoteDraftData): Promise<Quote> {
  const response = await apiClient.put<Quote>(`/Quote/${quoteId}/draft`, data);
  return response.data;
}

export async function sendQuote(quoteId: number): Promise<Quote> {
  const response = await apiClient.put<Quote>(`/Quote/${quoteId}/send`, {});
  return response.data;
}

export async function withdrawQuote(quoteId: number): Promise<Quote> {
  const response = await apiClient.put<Quote>(`/Quote/${quoteId}/withdraw`, {});
  return response.data;
}

export async function acceptQuote(quoteId: number): Promise<Quote> {
  const response = await apiClient.put<Quote>(`/Quote/${quoteId}/accept`, {});
  return response.data;
}

export async function declineQuote(quoteId: number, reason?: string): Promise<Quote> {
  const response = await apiClient.put<Quote>(`/Quote/${quoteId}/decline`, { reason });
  return response.data;
}
